
export default {
    test: {
        apphotel: 'http://wehoteltest.bestwehotel.com/wehotelapp/hotel/index.html#/detail?from=activity&innId=',
        mhotel: 'http://wehoteltest.bestwehotel.com/wehotelapp/hotel/index.html#/detail?&from=activity&innId=',
        mhoteljj: 'http://wehoteltest.bestwehotel.com/wehotelapp/hotel/index.html#/detail?&from=activity&_platform=jj&innId=',
        apphotellist: 'http://wehoteltest.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&',
        mhotellist: 'http://wehoteltest.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&',
        mhotellistjj: 'http://wehoteltest.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&_platform=jj&',
        mcitylist: 'http://wehoteltest.bestwehotel.com/wehotelapp/search/index.html#/city?from=activity&',
        mcitylistjj: 'http://wehoteltest.bestwehotel.com/wehotelapp/search/index.html#/city?_platform=jj&from=activity&',
        appcitylist: 'http://wehoteltest.bestwehotel.com/wehotelapp/search/index.html#/city?from=activity&',
    },
    prod: {
        apphotel: 'https://booking.bestwehotel.com/wehotelapp/hotel/index.html#/detail?from=activity&innId=',
        mhotel: 'https://wap.bestwehotel.com/wehotelapp/hotel/index.html#/detail?&from=activity&innId=',
        mhoteljj: 'https://wap.bestwehotel.com/wehotelapp/hotel/index.html#/detail?&from=activity&_platform=jj&innId=',
        apphotellist: 'https://booking.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&',
        mhotellist: 'https://wap.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&',
        mhotellistjj: 'https://wap.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&_platform=jj&',
        mcitylist: 'https://wap.bestwehotel.com/wehotelapp/search/index.html#/city?from=activity&',
        mcitylistjj: 'https://wap.bestwehotel.com/wehotelapp/search/index.html#/city?_platform=jj&from=activity&',
        appcitylist: 'https://booking.bestwehotel.com/wehotelapp/search/index.html#/city?from=activity&',
    }
}



// WEBPACK FOOTER //
// ./src/urlconfig.js